import {
  faCopy,
  faPlusSquare,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { ProjectModel } from "../../../base/models/projectModel";
import DatePicker from "react-date-picker";
import {
  allCategories,
  CategoryFromKey,
  web,
} from "../../../base/data/categories";
import {
  allFrameworks,
  flutter,
  FrameworkFromKey,
} from "../../../base/data/frameworks";
import { keyGenerator } from "../../../base/utils/keyGenerator";
import { update } from "../service/update";
import { addNew } from "../service/addNew";

interface Props {
  project?: ProjectModel;
  isUpdate?: boolean;
}

const ProjectFormView = ({ project, isUpdate = false }: Props) => {
  const [id, setId] = useState<string>(project ? project.id : "");
  const [key, setKey] = useState<string>(
    project ? project.key : keyGenerator()
  );
  const [isActive, setIsActive] = useState(!project?.isDeactive ? true : false);

  const [title, setTitle] = useState<string>(project ? project.title : "");
  const [category, setcategory] = useState<string>(
    project ? project.category.name : ""
  );
  const [description, setdescription] = useState<string>(
    project ? project.description : ""
  );
  const [coverImage, setcoverImage] = useState<string>(
    project ? project.coverImage : ""
  );
  const [images, setimages] = useState<string[]>(project ? project.images : []);
  const [image, setimage] = useState<string>("");

  const [framework, setframework] = useState<string>(
    project ? project.framework.name : ""
  );
  const [keywords, setkeywords] = useState<string[]>(
    project ? project.keywords : []
  );
  const [keyword, setkeyword] = useState<string>("");
  const [createdDate, setcreatedDate] = useState<Date>(
    project ? new Date(project.createdDate) : new Date()
  );
  const [latestUpdate, setlatestUpdate] = useState<Date>(
    project ? new Date(project.latestUpdate) : new Date()
  );
  const [longDescription, setlongDescription] = useState<string>(
    project && project.longDescription ? project.longDescription : ""
  );

  const [urls, setUrls] = useState(project && project.url ? project.url : []);
  const [url, setUrl] = useState("");

  const [message, setmessage] = useState("");

  const textInputStyle =
    "p-2 font-medium w-full border border-primary shadow-xl";

  function clearForms() {
    setId("");
    setKey(keyGenerator());
    setTitle("");
    setcategory("");
    setcoverImage("");
    setdescription("");
    setframework("");
    setimage("");
    setimages([]);
    setkeyword("");
    setkeywords([]);
    setlongDescription("");
  }

  async function handleSubmit() {
    const project: ProjectModel = {
      id: id,
      key: key,
      isDeactive: !isActive,
      category: CategoryFromKey(category) ?? web,
      title: title,
      url: urls,
      description: description,
      coverImage: coverImage,
      images: images,
      longDescription: longDescription,
      framework: FrameworkFromKey(framework) ?? flutter,
      keywords: keywords,
      createdDate: createdDate.toString(),
      latestUpdate: latestUpdate.toString(),
    };

    try {
      const response = isUpdate ? await update(project) : await addNew(project);
      response && response.data && setmessage("Success");
    } catch (error) {
      setmessage(`Error: ${error}`);
    }
  }

  useEffect(() => {
    async function offNotification() {
      setTimeout(() => {
        setmessage("");
      }, 2000);
    }

    if (message === "Success") {
      offNotification();
    }
  }, [setmessage, message, category, setframework]);

  return (
    <div className="w-full flex flex-col gap-4 ">
      {message !== "" && (
        <div
          className={`p-2 w-full ${
            message === "Success" ? "bg-green-300" : "bg-red-300"
          }`}
        >
          {message}
        </div>
      )}
      <div className="flex flex-col lg:flex-row gap-8 ">
        <div className="w-full lg:w-2/5 h-full">
          <div className="grid grid-cols-1 gap-4  ">
            <InputWidget title="Title">
              <input
                className={textInputStyle}
                onChange={(evt) => setTitle(evt.target.value)}
                value={title}
                type="text"
                name="Title"
                id="Title"
              />
            </InputWidget>

            <InputWidget title="Description">
              <input
                className={textInputStyle}
                onChange={(evt) => setdescription(evt.target.value)}
                type="text"
                value={description}
                name="Description"
                id="Description"
              />
            </InputWidget>

            <InputWidget title="Category">
              <select
                className={textInputStyle}
                name="category"
                defaultValue={category}
                id="category"
                onChange={(evt) => setcategory(evt.target.value)}
              >
                {allCategories.map((e, idx) => (
                  <option key={idx} value={e.key}>
                    {e.name}
                  </option>
                ))}
              </select>
            </InputWidget>

            <InputWidget title="Framework">
              <select
                className={textInputStyle}
                value={framework}
                name="framework"
                id="framework"
                onChange={(evt) => setframework(evt.target.value)}
              >
                {allFrameworks.map((e, idx) => (
                  <option key={idx} value={e.key}>
                    {e.name}
                  </option>
                ))}
              </select>
            </InputWidget>

            <InputWidget title="Images">
              <div className="inline-flex flex-col gap-2">
                <div className="inline-flex flex-row gap-2 items-center">
                  <input
                    className={textInputStyle}
                    onChange={(evt) => setimage(evt.target.value)}
                    type="text"
                    value={image}
                    name="image"
                    id="image"
                  />
                  <button
                    onClick={() => {

                      images && images.length > 0 ?
                      
                      setimages([...images, image]) :  setimages([image]) ;
                      setimage("");
                    }}
                    className="p-2 text-xl text-primary"
                  >
                    <FontAwesomeIcon icon={faPlusSquare} />
                  </button>
                </div>
                {images && images.length > 0 && (
                  <div className="inline-flex flex-col border border-primary p-3 bg-white">
                    {images.map((e, idx) => (
                      <div
                        key={idx}
                        className="inline-flex flex-row gap-2 items-center w-full  "
                      >
                        <span>{e.split("/").reverse()[0]}</span>
                        <button
                          placeholder="Copy path"
                          onClick={() => {
                            navigator.clipboard.writeText(e);
                          }}
                          className=" text-xl text-indigo-600"
                        >
                          <FontAwesomeIcon icon={faCopy} />
                        </button>
                        <button
                          onClick={() => {
                            const newArr = images.filter(
                              (element) => images.indexOf(element) !== idx
                            );
                            setimages(newArr);
                          }}
                          className=" text-xl text-red-500"
                        >
                          <FontAwesomeIcon icon={faTimes} />
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </InputWidget>

            <InputWidget title="isActive?">
              <input
                type="checkbox"
                className=""
                name="isActive"
                id="isActive"
                onChange={() => setIsActive(!isActive)}
                checked={isActive}
              />
            </InputWidget>

            <InputWidget title="Keywords">
              <div className="inline-flex flex-col gap-2">
                <div className="inline-flex flex-row gap-2 items-center">
                  <input
                    className={textInputStyle}
                    onChange={(evt) => setkeyword(evt.target.value)}
                    type="text"
                    value={keyword}
                    name="keyword"
                    id="keyword"
                  />
                  <button
                    onClick={() => {
                      setkeywords([...keywords, keyword]);
                      setkeyword("");
                    }}
                    className="p-2 text-xl text-primary"
                  >
                    <FontAwesomeIcon icon={faPlusSquare} />
                  </button>
                </div>
                {keywords && keywords.length > 0 && (
                  <div className="grid grid-cols-2 gap-4 border border-primary p-3 bg-white ">
                    {keywords.map((e, idx) => (
                      <div key={idx} className="text-sm">
                        <span>{e}</span>
                        <button
                          onClick={() => {
                            const newArr = keywords.filter(
                              (element) => keywords.indexOf(element) !== idx
                            );
                            setkeywords(newArr);
                          }}
                          className=" text-xl text-red-500 px-2"
                        >
                          <FontAwesomeIcon icon={faTimes} />
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </InputWidget>
          </div>
        </div>
        <div className="inline-flex w-full lg:w-3/5 flex-col gap-2">
          <div className="grid grid-cols-2 gap-8">
            <InputWidget title="Created Date">
              <DatePicker
                tileClassName={textInputStyle}
                onChange={setcreatedDate}
                value={createdDate}
              />
            </InputWidget>

            <InputWidget title="Latest Update">
              <DatePicker
                tileClassName={textInputStyle}
                onChange={setlatestUpdate}
                value={latestUpdate}
              />
            </InputWidget>
          </div>

          <InputWidget title="Cover Image">
            <input
              className={textInputStyle}
              onChange={(evt) => setcoverImage(evt.target.value)}
              type="text"
              value={coverImage}
              name="coverImage"
              id="coverImage"
            />
          </InputWidget>

          <InputWidget title="Urls">
            <div className="inline-flex flex-col gap-2">
              <div className="inline-flex flex-row gap-2 items-center">
                <input
                  className={textInputStyle}
                  onChange={(evt) => setUrl(evt.target.value)}
                  type="text"
                  value={url}
                  name="url"
                  id="url"
                />
                <button
                  onClick={() => {
                    setUrls([...urls, url]);
                    setUrl("");
                  }}
                  className="p-2 text-xl text-primary"
                >
                  <FontAwesomeIcon icon={faPlusSquare} />
                </button>
              </div>
              {urls && urls.length > 0 && (
                <div className="inline-flex flex-col gap-3 border font-medium text-xs flex-wrap border-primary p-3 bg-white">
                  {urls.map((e, idx) => (
                    <div
                      key={idx}
                      className="inline-flex flex-row gap-3 items-center w-full  "
                    >
                      <span>{e}</span>

                      <button
                        onClick={() => {
                          const newArr = urls.filter(
                            (element) => urls.indexOf(element) !== idx
                          );
                          setUrls(newArr);
                        }}
                        className=" text-xl text-red-500"
                      >
                        <FontAwesomeIcon icon={faTimes} />
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </InputWidget>

          <InputWidget title="Long Description">
            <textarea
              className={textInputStyle}
              onChange={(evt) => setlongDescription(evt.target.value)}
              name="longDescription"
              value={longDescription}
              id="longDescription"
              rows={20}
            ></textarea>
          </InputWidget>
        </div>
      </div>
      <div className="w-full flex flex-row justify-end">
        <div className="inline-flex flex-row gap-4">
          <button
            className="p-3 bg-primary text-light hover:opacity-70"
            onClick={() => clearForms()}
          >
            Clear
          </button>
          <button
            className="p-3 bg-primary text-light hover:opacity-70"
            onClick={() => handleSubmit()}
          >
            {isUpdate ? "Update Project" : "Add Project"}
          </button>
        </div>
      </div>
    </div>
  );
};

interface InputProps {
  title: string;
  children: React.ReactNode;
}

const InputWidget = ({ title, children }: InputProps) => {
  return (
    <>
      <div className="inline-flex flex-col w-full">
        <span className="font-medium">{title}</span>
        {children}
      </div>
    </>
  );
};

export default ProjectFormView;
